import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import MaterialsApi from '@/services/apiServiceModules/materialsApi'
const materialsApi = new MaterialsApi()

export default class MaterialsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.MATERIALS, materialsApi, {
			useCache: true,
		})
	}

	getCurrentPricesOfMaterials(companyId, query) {
		const config = {
			apiServiceMethodName: 'getCurrentPricesOfMaterials',
		}

		const apiMethodPayload = {
			urlParams: {
				companyId,
			},
		}

		if (query && typeof query === 'object') {
			apiMethodPayload.params = query
		}

		return this.dataTransferWrapMethod(this.moduleName, this.apiModule, config, apiMethodPayload)
	}
}
